import styled from 'styled-components'

import { MOBILE_HEADER_HEIGHT, SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

const PADDING = 16

export const AiImageContentContainer = styled.div<{
  $hasSelectedItem?: boolean
}>`
  padding-top: ${({ $hasSelectedItem }) => ($hasSelectedItem ? '24px' : '0')};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    height: calc(100dvh - ${MOBILE_HEADER_HEIGHT}px);
  }
`

/* Inset the segmented switcher to the panel's 16px gutter. The switcher has no
   bottom rule of its own (the old underline Tabbar did), so it carries its own
   separation from the tab content. */
export const TabbarWrapper = styled.div`
  width: calc(100% - ${PADDING * 2}px);
  margin: 0 auto 8px;
`
